/**
 * Shared Realtime playback lifecycle for Web and React SDK installations.
 * `response.done` closes generation only; speaking remains latched until the
 * WebRTC output buffer reports that device playback is fully drained.
 */
export class RealtimePlaybackLifecycle {
    callbacks;
    missingStopFallbackMs;
    fallbackTimer = null;
    playbackActive = false;
    responseComplete = false;
    disposed = false;
    constructor(callbacks, missingStopFallbackMs = 120_000) {
        this.callbacks = callbacks;
        this.missingStopFallbackMs = missingStopFallbackMs;
    }
    handleServerEvent(type) {
        if (this.disposed)
            return;
        if (type === "response.created") {
            this.responseComplete = false;
            this.clearFallback();
            return;
        }
        if (type === "output_audio_buffer.started"
            || type.includes("response.output_audio.delta")
            || type.includes("response.audio.delta")) {
            this.startPlayback();
            return;
        }
        if (type === "response.done") {
            this.responseComplete = true;
            this.scheduleFallback();
            return;
        }
        if (type === "output_audio_buffer.stopped") {
            this.stopPlayback("buffer-stopped");
        }
    }
    isPlaybackActive() {
        return this.playbackActive;
    }
    isResponseComplete() {
        return this.responseComplete;
    }
    interrupt() {
        this.stopPlayback("interruption");
    }
    dispose() {
        this.disposed = true;
        this.clearFallback();
        this.playbackActive = false;
        this.responseComplete = false;
    }
    startPlayback() {
        if (this.playbackActive)
            return;
        this.playbackActive = true;
        this.callbacks.onPlaybackStarted();
        if (this.responseComplete)
            this.scheduleFallback();
    }
    stopPlayback(reason) {
        if (!this.playbackActive && !this.responseComplete)
            return;
        this.clearFallback();
        this.playbackActive = false;
        this.responseComplete = false;
        this.callbacks.onPlaybackStopped(reason);
    }
    scheduleFallback() {
        if (!this.playbackActive || this.fallbackTimer !== null)
            return;
        this.fallbackTimer = globalThis.setTimeout(() => {
            this.fallbackTimer = null;
            if (!this.disposed && this.playbackActive && this.responseComplete) {
                this.stopPlayback("fallback");
            }
        }, this.missingStopFallbackMs);
    }
    clearFallback() {
        if (this.fallbackTimer !== null)
            globalThis.clearTimeout(this.fallbackTimer);
        this.fallbackTimer = null;
    }
}
